<script>
    let graph
    import { Typography } from './'
    let width = 100
    export let breakPoints = []
    export let current = 0
    $: if (current < 0) {
        current = 0
    } else if (current > breakPoints.length - 1) {
        current = breakPoints.length - 1
    }
</script>

<div>
    <div
        class="breakpoints"
        style={`padding: 0 ${50 / breakPoints.length / 2}%`}
    >
        <span
            class="line"
            style={`width: calc(100% - ${50 / breakPoints.length}%)`}
        >
            <span
                class="progress colored"
                style={`width: ${(100 / (breakPoints.length - 1)) * current}%`}
            ></span>
        </span>
        {#each breakPoints as _, i}
            <i
                class={`${i <= current ? 'colored' : ''} ${i === current ? 'active' : ''}`}
            ></i>
        {/each}
    </div>
    <div class="tags">
        {#each breakPoints as point, i}
            <Typography
                style={`padding: 0; margin: 0; text-align: center; width: ${50 / breakPoints.length}%`}
                type="subtitle"
                color={current === i ? 'brand' : 'grey-400'}
                >{point.label}</Typography
            >
        {/each}
    </div>
</div>

<style>
    div {
        width: 100%;
        display: flex;
        position: relative;
        flex-direction: column;
        justify-content: space-between;
        padding: 19px 0 14px 0;
    }
    div.breakpoints {
        height: 14px;
        align-items: center;
        /* padding: 0 10%; */
        margin: 0 0 8px 0;
        padding: 0;
        flex-direction: row;
    }
    div.tags {
        flex-direction: row;
        padding: 0;
    }
    i {
        width: 8px;
        height: 8px;
        display: block;
        background: var(--color-grey-400);
        position: relative;
        border-radius: 50%;
        transition: all 0.2s ease-in-out;
    }
    i.active {
        /* width: 14px;
        height: 14px; */
        transform: scale(1.75);
    }
    span.line {
        height: 2px;
        top: 6px;
        background: var(--color-grey-400);
        padding: 0;
        /* width: 100%; */
        position: absolute;
    }
    span.progress {
        margin: 0;
        display: block;
        position: relative;
        height: 100%;
    }
    span {
        transition: all 0.2s ease-in-out;
    }
    .colored {
        background: var(--color-brand-primary-01);
    }
</style>
